import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DatasourcesDisplayGridRowDataFragmentGql } from './DatasourcesDisplayGridRowDataFragmentGql';

export const FlowDownstreamDatasourcesQueryGql: DocumentNode = gql`
query FlowDownstreamDatasourcesQuery($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    downstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowDataFragment
      }
    }
  }
}
${DatasourcesDisplayGridRowDataFragmentGql}
`;
